import './index.less';

import CommonIframe from './CommonIframe.vue';

CommonIframe.install = function install(Vue) {
  Vue.component(CommonIframe.name, CommonIframe);
};

export default CommonIframe;
